import { IFetchedAnswer } from 'common/interfaces/answer';
import { IQuestionWithOptionInfo } from 'common/interfaces/question';
import { IToggleSide } from 'components/action';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';
import capitalize from 'lodash-es/capitalize';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';
import {
  QuestionOptionText,
  QuestionOptionSelect,
  QuestionOptionCheckbox,
  QuestionOptionRadio,
} from './..';

// Styles
const s = require('./../LeadQuestions.css');

// Props
interface IQuestionOptionProps extends IAppOnlyStore {
  questionInfo: IQuestionWithOptionInfo;
  answerDetails: IFetchedAnswer | null;
  unanswered: boolean;
}

// Component
@inject('store')
@observer
export class QuestionOption extends React.Component<IQuestionOptionProps, {}> {
  constructor(props: IQuestionOptionProps) {
    super(props);
  }

  public render() {
    const { questionInfo, answerDetails } = this.props;

    const renderOptionFunction = 'render' + capitalize(questionInfo.type);

    if (typeof this[renderOptionFunction] !== 'undefined') {
      return (
        <div>
          {this[renderOptionFunction]()}

          <SavingIndicator
            className={s.questionSavingIndicator}
            labels={{ saving: 'Saving changes' }}
            status={
              answerDetails !== null && answerDetails.saving
                ? SavingIndicatorStatus.Saving
                : SavingIndicatorStatus.None
            }
          />
        </div>
      );
    } else {
      console.error(
        `Question / answer of type ${questionInfo.type} is not implemented`
      );
      return null;
    }
  }

  private renderText() {
    const { answerDetails } = this.props;

    return (
      <QuestionOptionText
        onChange={this.handleTextChange}
        value={answerDetails && answerDetails.note ? answerDetails.note : ''}
        placeholder="Answer..."
      />
    );
  }

  private handleTextChange = (html: string, text: string) => {
    this.props.store.answer.changeAnswerNote(
      this.props.answerDetails !== null ? this.props.answerDetails.id : null,
      this.props.questionInfo,
      text.trim(),
      html
    );
  };

  private renderRadio() {
    const { answerDetails } = this.props;

    return (
      <QuestionOptionRadio
        onChange={this.handleRadioChange}
        options={this.props.questionInfo.option as any}
        value={
          answerDetails !== null &&
          answerDetails.answer &&
          answerDetails.answer.length > 0
            ? typeof answerDetails.answer[0] === 'object' &&
              typeof answerDetails.answer[0].id !== 'undefined'
              ? answerDetails.answer[0].id
              : answerDetails.answer[0]
            : null
        }
      />
    );
  }

  private handleRadioChange = (radio: IToggleSide) => {
    this.props.store.answer.changeAnswerValue(
      this.props.answerDetails !== null ? this.props.answerDetails.id : null,
      this.props.questionInfo,
      radio.value,
      radio.label
    );
  };

  private renderCheckbox() {
    const { questionInfo, answerDetails } = this.props;

    return (
      <div>
        <QuestionOptionCheckbox
          onChange={this.handleCheckboxChange}
          optionsTable={questionInfo.optionTable}
          options={
            typeof questionInfo.option !== 'undefined' &&
            questionInfo.option &&
            questionInfo.option.length > 0
              ? questionInfo.option.map((option, i) => ({
                  id: option.id,
                  name: option.name,
                }))
              : null
          }
          value={
            answerDetails !== null &&
            answerDetails.answer &&
            answerDetails.answer.length > 0
              ? typeof answerDetails.answer[0] === 'object' &&
                typeof answerDetails.answer[0].id !== 'undefined'
                ? answerDetails.answer.map((answer, i) => answer.id)
                : answerDetails.answer
              : null
          }
        />

        {questionInfo.note === 1 && (
          <QuestionOptionText
            className={s.checkboxesOtherTextField}
            onChange={this.handleTextChange}
            value={
              answerDetails && answerDetails.note ? answerDetails.note : ''
            }
            placeholder="Other..."
          />
        )}
      </div>
    );
  }

  private handleCheckboxChange = (box: { checked: boolean; value: any }) => {
    this.props.store.answer.changeAnswerCheckbox(
      this.props.answerDetails !== null ? this.props.answerDetails.id : null,
      this.props.questionInfo,
      box.checked,
      box.value
    );
  };

  private renderSelect() {
    const { questionInfo, answerDetails, store } = this.props;

    let options: Array<{ id: any; name: string }> = [];
    switch (questionInfo.optionTable) {
      case 'wholesaler':
        options = questionInfo.option.map((option, i) => ({
          id: option.id,
          name: option.wholesaler,
        }));
        break;

      case 'sourcing_program':
        const sourcingPrograms =
          store.answer.primaryWholesalerSourcingProgramsIds !== null
            ? questionInfo.option.filter(
                (option) =>
                  store.answer.primaryWholesalerSourcingProgramsIds.indexOf(
                    option.id
                  ) !== -1
              )
            : questionInfo.option;
        options = sourcingPrograms.map((option, i) => ({
          id: option.id,
          name: option.program,
        }));
        break;

      case 'buying_group':
        options = questionInfo.option.map((option, i) => ({
          id: option.id,
          name: option.groupCode + ' - ' + option.groupName,
        }));
        break;

      default:
        break;
    }

    return (
      <div>
        <QuestionOptionSelect
          onChange={this.handleSelectChange}
          optionsTable={questionInfo.optionTable}
          options={options}
          value={
            answerDetails !== null && answerDetails.answer
              ? answerDetails.answer
              : null
          }
        />

        {questionInfo.note === 1 && (
          <QuestionOptionText
            className={s.checkboxesOtherTextField}
            onChange={this.handleTextChange}
            value={
              answerDetails && answerDetails.note ? answerDetails.note : ''
            }
            placeholder="Other..."
          />
        )}
      </div>
    );
  }

  private handleSelectChange = (selected: { value: any; label: string }) => {
    this.props.store.answer.changeAnswerSelect(
      this.props.answerDetails !== null ? this.props.answerDetails.id : null,
      this.props.questionInfo,
      selected.value
    );
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Questions/Question/QuestionOption.tsx